import classNames from "classnames";
import styles from "../../pages.module.scss";
import useTitle from "../../hooks/useTitle.js";
import { Group, Paper, Text } from "@mantine/core";
import {
  IconBed,
  IconChevronDown,
  IconDownload,
  IconHistory,
  IconTool,
  IconTools,
  IconUsers,
} from "@tabler/icons-react";
import { useFetch } from "../../helpers/useFetch.js";
import { useLoaderData, useNavigate } from "react-router-dom";
import RoomGroupList from "../../components/accommodation/room-management/RoomGroupList.jsx";
import Page from "../../components/layout/Page.jsx";
import RoomIssuesTable from "../../components/table/RoomIssuesTable.jsx";
import { openRoomIssueModal } from "../../helpers/modals.js";

export async function loader() {
  const res = await useFetch(`accommodation/rooms/issues`);

  return res;
}

export default function RoomIssuesPage() {
  const rooms = useLoaderData().data;
  const navigate = useNavigate();
  useTitle(`Přehled škod`);

  const actionButtons = [
    {
      name: "Správa pokojů",
      onTrigger: (e) => {
        e.stopPropagation();
        navigate("/ubytovani/pokoje");
      },
      icon: IconBed,
    },
    {
      name: "Archiv škod",
      onTrigger: (e) => {
        e.stopPropagation();
        navigate("/ubytovani/skody/archiv");
      },
      icon: IconHistory,
    },
    {
      name: "Přidat škodu",
      onTrigger: (e) => {
        e.stopPropagation();
        openRoomIssueModal("Přidání škody", null, "");
      },
      icon: IconTool,
      primary: true,
    },
  ];

  return (
    <Page title="Přehled škod" actionIcons={actionButtons}>
      <RoomIssuesTable rooms={rooms} />
    </Page>
  );
}
